/* global $, Typed */

/**
 * formula PC
 */
function formulaFont() {
  $('#suitable').hover(() => {
    $('.suitable-text').toggleClass('suitable-open');
    $('.customizable-text').toggleClass('suitable-open');
    $('.actionable-text').toggleClass('suitable-open');
    $('.reliable-text').toggleClass('suitable-open');

    $('#x-stroke-1').toggleClass('suitable-open');
    $('#x-stroke-2').toggleClass('suitable-open');
    $('#x-stroke-3').toggleClass('suitable-open');

    $('.suitable-content').toggleClass('suitable-open');
  });

  $('#customizable').hover(() => {
    $('.suitable-text').toggleClass('customizable-open');
    $('.customizable-text').toggleClass('customizable-open');
    $('.actionable-text').toggleClass('customizable-open');
    $('.reliable-text').toggleClass('customizable-open');

    $('#x-stroke-1').toggleClass('customizable-open');
    $('#x-stroke-2').toggleClass('customizable-open');
    $('#x-stroke-3').toggleClass('customizable-open');

    $('.customizable-content').toggleClass('customizable-open');
  });

  $('#actionable').hover(() => {
    $('.suitable-text').toggleClass('actionable-open');
    $('.customizable-text').toggleClass('actionable-open');
    $('.actionable-text').toggleClass('actionable-open');
    $('.reliable-text').toggleClass('actionable-open');

    $('#x-stroke-1').toggleClass('actionable-open');
    $('#x-stroke-2').toggleClass('actionable-open');
    $('#x-stroke-3').toggleClass('actionable-open');

    $('.actionable-content').toggleClass('actionable-open');
  });

  $('#reliable').hover(() => {
    $('.suitable-text').toggleClass('reliable-open');
    $('.customizable-text').toggleClass('reliable-open');
    $('.actionable-text').toggleClass('reliable-open');
    $('.reliable-text').toggleClass('reliable-open');

    $('#x-stroke-1').toggleClass('reliable-open');
    $('#x-stroke-2').toggleClass('reliable-open');
    $('#x-stroke-3').toggleClass('reliable-open');

    $('.reliable-content').toggleClass('reliable-open');
  });

  $('#x-stroke-1').hover(() => {
    $('.suitable-text').toggleClass('x-stroke-1-open');
    $('.customizable-text').toggleClass('x-stroke-1-open');
    $('.actionable-text').toggleClass('x-stroke-1-open');
    $('.reliable-text').toggleClass('x-stroke-1-open');

    $('#x-stroke-1').toggleClass('x-stroke-1-open');
    $('#x-stroke-2').toggleClass('x-stroke-1-open');
    $('#x-stroke-3').toggleClass('x-stroke-1-open');
  });

  $('#x-stroke-2').hover(() => {
    $('.suitable-text').toggleClass('x-stroke-2-open');
    $('.customizable-text').toggleClass('x-stroke-2-open');
    $('.actionable-text').toggleClass('x-stroke-2-open');
    $('.reliable-text').toggleClass('x-stroke-2-open');

    $('#x-stroke-1').toggleClass('x-stroke-2-open');
    $('#x-stroke-2').toggleClass('x-stroke-2-open');
    $('#x-stroke-3').toggleClass('x-stroke-2-open');
  });

  $('#x-stroke-3').hover(() => {
    $('.suitable-text').toggleClass('x-stroke-3-open');
    $('.customizable-text').toggleClass('x-stroke-3-open');
    $('.actionable-text').toggleClass('x-stroke-3-open');
    $('.reliable-text').toggleClass('x-stroke-3-open');

    $('#x-stroke-1').toggleClass('x-stroke-3-open');
    $('#x-stroke-2').toggleClass('x-stroke-3-open');
    $('#x-stroke-3').toggleClass('x-stroke-3-open');
  });
}

let typedStatus = 1;

$(window).scroll(() => {
  if ($('#formulaSec').offset().top - 300 < $(window).scrollTop() && typedStatus) {
    typedStatus = 0;
    (() => new Typed('#formula-typed-text', {
      stringsElement: '#formula-typed-strings',
      typeSpeed: 15,
      showCursor: false,
      onStringTyped: formulaFont,
    }))();
  }
});

/**
 * formula mobile
 */
$('#formula-typed-m').click((e) => {
  if (e.target.nodeName !== 'SPAN') return;
  const clickDOM = e.target.dataset.open;
  $(`.${clickDOM}`).parent().find('div').removeClass('open');
  $(`.${clickDOM}`).toggleClass('open');
});
